import { render, staticRenderFns } from "./ModalRobux.vue?vue&type=template&id=5d28454d&scoped=true"
import script from "./ModalRobux.vue?vue&type=script&lang=js"
export * from "./ModalRobux.vue?vue&type=script&lang=js"
import style0 from "./ModalRobux.vue?vue&type=style&index=0&id=5d28454d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d28454d",
  null
  
)

export default component.exports